export default __webpack_public_path__ + "static/media/pq_logo.42765759.png";